import React, { useState, useEffect } from 'react';
import { useNavigate, Route, Routes, useLocation } from 'react-router-dom';
import './index.css';
import { Layout, Menu, Image, Space, Form, Typography } from 'antd';
import { Notifications, UserDropdown } from '../../components/Header';
import { SingleViewAppointment, SingleViewNotification, SingleViewPayment, SingleViewProject, SingleViewTransaction } from '../../components';
import { Dashboard } from '../Dashboard';
import { Login } from '../Login';
import { Appointment } from '../Appointment';
import { Payment } from '../Payment';
import { Transaction } from '../Transaction';
import { Notificationpage } from '../Notificationpage';
import { MessageBox } from '../MessageBox';
import { Settings } from '../Settings';

const { Header, Sider, Content } = Layout;
const Sidebar = () => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [items, setItems] = useState([]);
  const [currentTab, setCurrentTab] = useState('1');
  const [openKeys, setOpenKeys] = useState(['']);
  

  function getItem(label, key, icon, children) {
    return { key, icon, children, label };
  }

  useEffect(() => {
    let tab = location?.pathname?.split("/")[1];
    tab = tab === '' ? '1' :
          tab === 'appointment' ? '2' :
          tab === 'payment' ? '3' :
          tab === 'transactions' ? '4' :
          tab === 'notification' ? '5' :
          tab === 'chat' ? '6' :
          tab === 'setting' ? '7' :
      '1';
    setCurrentTab(tab);
  }, [location]);

  useEffect(() => {
    let itemsArr = [
      getItem('Dashboard', '1',
        currentTab === '1' ? 
        <img src="/assets/icons/dash-w.png" width={'15px'} alt="" /> :
        <img src="/assets/icons/dash-b.png" width={'15px'} alt="" />
      ),
    getItem('Appointment', '2',
      currentTab === '2' ? 
      <img src="/assets/icons/appointment-w.png" width={'15px'} alt="" /> :
      <img src="/assets/icons/appointment-b.png" width={'15px'} alt="" />
    ),
    getItem('Payment', '3',
      currentTab === '3' ? 
      <img src="/assets/icons/payment-w.png" width={'15px'} alt="" /> :
      <img src="/assets/icons/payment-b.png" width={'15px'} alt="" />
    ),
    getItem('Transaction History', '4',
      currentTab === '4' ? 
      <img src="/assets/icons/t-history-w.png" width={'15px'} alt="" /> :
      <img src="/assets/icons/t-history-b.png" width={'15px'} alt="" />
    ),
    getItem('Notification', '5',
      currentTab === '5' ? 
      <img src="/assets/icons/noti-w.png" width={'18px'} alt="" /> :
      <img src="/assets/icons/noti-b.png" width={'18px'} alt="" />  
    ),
    getItem('Chat', '6',
      currentTab === '6' ? 
      <img src="/assets/icons/chat-w.png" width={'18px'} alt="" /> :
      <img src="/assets/icons/chat-b.png" width={'18px'} alt="" />  
    ),
      getItem('Settings', '7',
        currentTab === '7' ? 
        <img src="/assets/icons/settings-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/settings-b.png" width={'18px'} alt="" />  
      ),
    ];

    setItems([...itemsArr]);
  }, [currentTab]);


  const handleMenuClick = (e) => {
    const { key } = e;
    switch (key) {
      case '1':
        navigate("/", { replace: true });
        break;
        case '2':
        navigate("/appointment", { replace: true });
        break;
        case '3':
          navigate("/payment", { replace: true });
          break;
          case '4':
          navigate("/transactions", { replace: true });
          break;
          case '5':
          navigate("/notification", { replace: true });
          break;
          case '6':
          navigate("/chat", { replace: true });
          break;
      case '7':
        navigate("/setting", { replace: true });
        break;
      
      default:
        break;
    }
  };

 
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
    // localStorage.setItem('openKeys', JSON.stringify(keys));
  };
  return (
    <Layout style={{ height: '100vh' }}>
      <Sider breakpoint="md"
        collapsedWidth="80"
        onBreakpoint={(broken) => {
          setCollapsed(broken)
        }} trigger={null} collapsible collapsed={collapsed} className={collapsed ? 'addclass' :''} style={{ height: '100vh', overflowY: 'auto',borderRight:'1px solid #E3E3E3'}}>
        <div className="logo" style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            style={{ width: collapsed ? "100%" : '60px' }}
            height={'auto'}
            src="/assets/images/logo.png"
            alt='Rental Admin Panel'
            preview={false}
          />
        </div>
        <Menu
          defaultSelectedKeys={['1']}
          selectedKeys={[currentTab]}
          mode="inline"
          theme="dark"
          onClick={handleMenuClick}
          onOpenChange={onOpenChange}
          openKeys={openKeys}
          items={items}
          className={collapsed ? 'addmenu' :'listitem'}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background header-mbl-cs shadow-d"
          style={{
            padding: 0,
            display: 'flex',
            paddingLeft:0,
            justifyContent: 'center'
          }}
        >
          <div style={{ width: '98%', display: 'flex', justifyContent: 'space-between',alignItems:'center',position:'relative',gap:5, }}>
            <Space className='w-100 mbl-space'>
              <div className='trigger' onClick={() => setCollapsed(!collapsed)}>
                <Image src='/assets/icons/collapse.png' 
                  width={'35px'} preview={false} 
                  style={{transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)'}}  
                />
              </div>
              {/* <Image src='/assets/icons/stars-t.png' 
                width={'25px'} preview={false} 
              /> */}
              <Typography.Title className='m-0 fw-500' level={5}>
                Welcome to Client Panel!
              </Typography.Title>
            </Space>
            <Space size={15}>
              <Notifications />
              <UserDropdown />
            </Space>
          </div>
        </Header>
        
        <Content
          className="scroll-bar"
          style={{
            margin: '24px 10px',
            padding: '0 15px',
            minHeight: 280,
            overflowY: 'auto',
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/projects/detail/:proId" element={<SingleViewProject />} />
            <Route path="/appointment" element={<Appointment/>}/>
            <Route path="/appointment/detail/:appId" element={<SingleViewAppointment />} />
            <Route path='/payment' element={<Payment/>}/>
            <Route path='/payment/detail/:payId' element={<SingleViewPayment/>}/>
            <Route path='/transactions' element={<Transaction/>}/>
            <Route path='/transactions/detail/:tId' element={<SingleViewTransaction/>}/>
            <Route path="/notification" element={<Notificationpage />} />
            <Route path="/notification/detail/:notiId" element={<SingleViewNotification />} />
            <Route path="/chat" element={<MessageBox />} />
            <Route path='/setting' element={<Settings />} />
           </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Sidebar;
